module.exports = __webpack_public_path__ + "static/img/packages-list-title1.551e92aa.png";